import { writable } from 'svelte/store';

function createStore() {
    const { subscribe, set, update } = writable({});

    return {
        subscribe,
        set: (message) => {
            set(message);
        },
        update: (message) => {
            update(message);
        }
    }
}

export const messaging = createStore(); 